export default __webpack_public_path__ + "static/media/logo.cc11e898.png";